// extracted by mini-css-extract-plugin
export default {"wrapper":"kG-z","button":"lG-z","alternate":"mG-z","disabled":"nG-z","paymentWarning":"oG-z","fadeIn":"pG-z"};